<div class="overlay" [ngClass]="{ 'is-open': isOpen }">
  <div class="overlay-content-container"
    [ngClass]="{ 'wide-mode': bigSize, 'narrow-mode': !bigSize }">
    @if (overlayContent) {
      <ng-container *ngTemplateOutlet="overlayContent.template"></ng-container>
    }
  </div>
</div>
<div class="sidebar" [ngClass]="{ 'is-open': isOpen, 'wide-sidebar': bigSize, 'narrow-sidebar': !bigSize }">
  @if (showDefaultHeader) {
    <div class="sidebar-header">
      <button class="custom-button" (click)="closeSidebar()" type="button">
        <img src="assets/icons/close-icon.png" alt="Hide button" />
      </button>
    </div>
  }

  <div id="sidebarContent">
    <ng-content></ng-content>
  </div>
</div>
